import React, { useMemo } from 'react';
import EChartCommon from '@op/components/EChartCommon';
import { echartsContent } from '@/pages/opinion/utils';
import mobileGameDefaultIcon from '@/pages/opinion/assets/svg/mobile-game-default.svg';
import {
  echartTooltipTime,
  formatChartParamsDate,
} from '@/pages/opinion/components/ChartCommon/formatter';
import { reviewsFormat } from '@/pages/opinion/utils/value';
import { useIntl } from 'umi';
import { chartAllColors } from '@/pages/opinion/constants';
import { getIconInfo } from './utils';
import { xArr } from '../../hooks/useGameChartRich';

export default function BarChart({
  height,
  data,
  filter,
  title,
  formatValue = reviewsFormat,
  showName = true,
}: any) {
  const { formatMessage } = useIntl();
  // 设置图形配置
  const options = useMemo(() => {
    let seriesData: any = [];
    let legendData: any = [];
    let xAxisData: any = [];
    let xRich: any = {};
    data?.forEach((item: any, index: number) => {
      legendData.push({
        name: item.name,
        icon: 'circle',
        itemStyle: {
          color: chartAllColors[index],
        },
      });
      xAxisData.push(item.name);
      seriesData.push({
        name: item.name,
        value: item.value,
        cover: item?.cover ? item?.cover : mobileGameDefaultIcon,
        itemStyle: {
          color: chartAllColors[index],
        },
      });
      xRich[xArr[index]] = {
        backgroundColor: {
          image: item?.cover ? item?.cover : mobileGameDefaultIcon,
        },
        align: 'center',
        width: 25,
        height: 25,
      };
    });

    const option = {
      tooltip: {
        formatter: (param: any) => {
          let { name, cover } = param?.[0]?.data || {};
          return formatChartParamsDate({
            params: param,
            textShowFun: (marker: string) => getIconInfo(cover, name, marker),
            valueFormat: (value) => formatValue(value),
            tablesConfigFunc: (records: Array<any>) => [
              {
                showHeader: true,
                records,
                columns: [
                  {
                    key: 'text',
                    header: echartTooltipTime(filter),
                  },
                  {
                    key: 'value',
                    align: 'right',
                    weight: 'bold',
                    header: formatMessage({ id: title }),
                  },
                ],
              },
            ],
          });
        },
      },
      xAxis: [
        {
          data: xAxisData,
          axisLabel: {
            interval: 0,
            formatter: function (value: any, index: number) {
              return (
                `{${xArr[index]}|}` +
                (showName ? '\n\n{avanametar|' + value + '}' : '')
              );
            },
            width: 60,
            overflow: 'truncate',
            ellipsis: '...',
            rich: {
              value: {
                lineHeight: 30,
                align: 'center',
                width: 300,
                height: 300,
              },
              ...xRich,
            },
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: (value: string) => echartsContent(value),
          },
        },
      ],
      grid: {
        right: 20,
        bottom: 0,
        top: 6,
        containLabel: true,
      },
      series: [
        {
          data: seriesData,
          type: 'bar',
        },
      ],
    };
    return option;
  }, [formatMessage, data]);

  return (
    <EChartCommon
      options={options}
      optionsProps={{ type: 'bar', excludeOptions: ['axisPointer'] }}
      height={height}
    ></EChartCommon>
  );
}
